import 'css/base/variables.css'; // variaveis
import 'css/vendor/tippy-js.css';
import 'tippy.js/animations/shift-away-subtle.css';
import "css/index.css"; // entrada


console.log('Quarta 24 de 07 as 12:46');

document
	.addEventListener("DOMContentLoaded", () =>
		document.body.classList.add("DOMContentLoaded")
	)


